<template>
  <div  class="Mcontainer" >
  
    <!-- <div id="border2"></div>
    <div id="border1"></div>
    <div id="mainM"></div> -->
    <svg class="particle-container" ref="container"
    width="48" height="48" viewBox="0 0 1000 1000"
    xmlns="http://www.w3.org/2000/svg">
    
    </svg>
    <!-- <svg width="48" height="48" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
<path d="M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58Z"></path>
</svg> -->
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {mapGetters} from "vuex"
export default {
name:"MainM",
data(){
  return{
    
    colors: ["blue","red","yellow","magenta","cyan"],
    defaultStyle:{
      transform:"rotate(7deg)",
      display:"inline-table",
      position:"absolute",
      top:"0px",
      left:"0px",
      "z-index":"20",
      "margin-top":"10px",
      transition:"all 3s ease-in-out"
    }
  }
},
computed:{
  ...mapGetters([
      'getColorsArray'
    ])
},
methods:{
  createParticle(){
    let signs = ["x","^","+","-","*"]
    let el = this.$refs.container
    let icons = []
    console.log(library,library.definitions.fab.airbnb[4]);
    for (let i = 0; i < 2 ; i++) {
      let newIcon = document.createElement("path")
      newIcon.textContent =  signs[Math.floor(Math.random() * signs.length)]
      // newIcon.setAttribute("viewBox","0 0 1000 1000")
      newIcon.setAttribute("fill", this.colors[Math.floor(Math.random() * this.colors.length)])     
      newIcon.setAttribute("d",library.definitions.fab.airbnb[4]) 
      el.appendChild(newIcon)
      this.applyStyle(newIcon)
      
      icons.push(newIcon)
    }
    //this.tick(icons)
        
  },
  tick(icons){
     setTimeout(()=>{ 
       icons.forEach(icon => {
          this.defaultStyle["transform"] = `rotate(${Math.random()*1000}deg)`
          this.defaultStyle["top"] = `${Math.random()*120-20}px`
          this.defaultStyle["left"] = `${Math.random()*200-20}px`
          this.applyStyle(icon)
       });
      this.tick(icons)
     }, 3000);
  },
  applyStyle(el){
    Object.keys(this.defaultStyle).forEach(key => {
      el.style[key] = this.defaultStyle[key]
    });
    return el
  }
},
mounted(){
  this.createParticle()
}
}
</script>

<style lang="scss" scoped>
@keyframes mymove {
  0%   {top: 0px;}
  // 10%  {top: 10px;}
  // 20%  {top: 5px;}
  40%  {top: 15px;}
  80%  {top: 0px;}
  100% {top: 0px;}
}
path{
  width:16px;
  height: 16px;
  stroke: #2c3e50;
  stroke-width: 2 ;
}
.Mcontainer{
  position: relative;
}
.particle-container{
  width:200px;
  height: 200px;
}
#mainM{
  width:200px;
  height: 200px;
  position:absolute;
  top:0px;
  left:5px;
  //animation-delay: 0.3s;
  animation: mymove infinite ease-in-out;
  animation-duration: 10s;
  background-image: url("../assets/m_filled.svg") ;
}
#border1{
  width:200px;
  height: 200px;
  position:absolute;
  margin-top:6px;
  left:1px;
  animation: mymove infinite ease-in-out;
  animation-delay: 0.7s;
  animation-duration: 10s;
  background-image: url("../assets/m_outline.svg") ;
}

#border2{
  width:200px;
  height: 200px;
  position:absolute;
  margin-top:10px;
  left:-5px;
  animation: mymove infinite ;
  animation-delay: 1.4s;
  animation-duration: 10s;
  background-image: url("../assets/m_outline2.svg") ;
}
</style>